import React from "react";
import LandingNoData from "../../components/schedaCliente/landingNoData";
import { useSelector } from "react-redux";
import Page from "../../components/general/page";
import { useLocation } from "react-router-dom";

const LandingNoDataView = props => {
  const {  pageRef } = props;
  const location = useLocation();
  const myType = useSelector(state => state.main.myType);
  const notAuthorized =
    location.state && location.state.notAuthorized
      ? location.state.notAuthorized
      : localStorage.getItem("landingAuth") &&
        localStorage.getItem("landingAuth") === "true"
        ? localStorage.getItem("landingAuth")
        : false;
  return (
    <Page pageRef={pageRef} activePage={"/scheda-cliente"} noHeaderContent noClassName>
      <div className={"contentStructure"}>
        {myType === "STUDIO" ? (
          <LandingNoData notAuthorized={notAuthorized} />
        ) : null}
      </div>
    </Page>
  );
};

export default LandingNoDataView;
